<template>
  <div>
    <div id="location-progress-bar-chart">
      <apexchart type="bar" :height="chartHeight" :options="barChartOptions" :series="series" />
    </div>
    <div class="chart-legend">
      <div class="legend-item">
        <span class="legend-swatch swatch-low"></span>
        <span>0% - 32%</span>
      </div>
      <div class="legend-item">
        <span class="legend-swatch swatch-mid"></span>
        <span>33% - 65%</span>
      </div>
      <div class="legend-item">
        <span class="legend-swatch swatch-high"></span>
        <span>66% - 100%</span>
      </div>
      <div class="legend-item">
        <span class="legend-swatch swatch-remain"></span>
        <span>Remaining</span>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';


export default {
  props: {
    menteeNames: {
      type: Array,
      default() {
        return [];
      },
    },
    seriesValues: {
      type: Array,
      default() {
        return [];
      },
    },
    seriesName: {
      type: String,
      default: 'Mentee Progress',
    },

  },
  data() {
    return {

    }
  },
  computed: {
    resolvedSeriesValues() {
      return this.seriesValues.map((value) => {
        const numericValue = Number(value);
        if (Number.isNaN(numericValue)) {
          return 0;
        }
        if (numericValue < 0) {
          return 0;
        }
        if (numericValue > 100) {
          return 100;
        }
        return numericValue;
      });
    },
    resolvedLocationNames() {
      const fallbackPrefix = 'Location ';
      return this.resolvedSeriesValues.map((_, index) => {
        return this.menteeNames[index];
      });
    },
    series() {
      return [
        {
          name: 'Pathway Progress',
          data: this.resolvedSeriesValues,
        },
        {
          name: 'Remaining',
          data: this.resolvedSeriesValues.map(v => 100 - v)
        }
      ];
    },
    chartHeight() {
      const minRows = 1;
      const rowHeight = 36;
      const verticalPadding = 40;
      const rowCount = Math.max(this.resolvedLocationNames.length, minRows);
      let height = rowCount * rowHeight + verticalPadding;
      if (height < 220) {
        height = 220;
      }
      
      return height;
    },
    barChartOptions() {
      const getColor = (val) => {
        if (val >= 0 && val <= 32) return '#EE4200';
        if (val >= 33 && val <= 65) return '#f4d454';
        return '#009118';
      };
      return {
        chart: {
          id: 'location_bar_chart',
          type: 'bar',
          stacked: true,
          stackType: 'normal',
          height: this.chartHeight,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
            barHeight: '25px',
            dataLabels: {
              position: 'top',
            },
          },
        },
        colors: [
          ({ value }) => getColor(value), // dynamic color
          '#E5E7EB' // remaining
        ],
        dataLabels: {
          enabled: true,
          offsetX: 10,
          textAnchor: 'start',
          formatter(value) {
            //return value + '%';
          },
          style: {
            colors: ['#1f2937'],
          },
        },
        xaxis: {
          min: 0,
          max: 100,
          tickAmount: 4,
          categories: this.resolvedLocationNames,
          labels: {
            formatter(value) {
              return value + '%';
            },
          },
        },
        grid: {
          padding: {
            right: 24,
          },
          strokeDashArray: 4,
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        legend: {
          show: false,
        },
        fill: {
          opacity: 1
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            },
          },
          active: {
            filter: {
              type: 'none',
            },
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          fixed: {
            enabled: true,
            position: 'topRight' // try: topLeft, bottomRight
          },
          custom: function({ series, dataPointIndex, w }) {
            const progress = series[0][dataPointIndex];
            const remaining = series[1][dataPointIndex];
            const label = w.globals.labels[dataPointIndex];
            const color = getColor(progress);
            return `
              <div style="padding:8px; font-size: 13px;">
                <div style=" font-size: 15px;"><strong>${label}</strong></div>
                <div style="background: ${color};width: 10px; height: 10px;display: inline-block;border-radius: 0;"></div> Pathway Progress: ${progress}%<br />
                <div style="background: #E5E7EB;width: 10px; height: 10px;display: inline-block;border-radius: 0;"></div> Remaining: ${remaining}%
            `;
          }
        },
      };
    },
  },
  components: {
    apexchart: VueApexCharts,
  },
};
</script>

<style scoped>
.chart-legend {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #374151;
}

.legend-swatch {
  width: 10px;
  height: 10px;
  margin-right: 8px;
  display: inline-block;
}

.swatch-low {
  background: #EE4200;
}

.swatch-mid {
  background: #f4d454;
}

.swatch-high {
  background: #009118;
}

.swatch-remain {
  background: #E5E7EB;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/pathway_progress_barchart.vue